import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { Icon } from "@/comn/components";
import { useLogin } from "../../authentication/useLogin";
import { DevAccountButton } from "../../authentication/DevAccounts";
import { _TEST1234 } from "../../config/ApiConfig";
import { useAuth } from "@/comn/hooks";
import { InputPassword } from "@/comn/components/_";
import { DEV_ACCOUNT_OSC } from "./Dev_Accounts";

export const LoginForm = (props: any) => {
    const navigate = useNavigate();
    const {
        loginForm: {
            id,
            pwd,
            lcm,
            type,
            coTpList,
            coCd,
            cstmCd,
            usrCstmList,
            loading,
        },
        setLoginForm,
        handleSubmitLogin,
        handleSubmitCustom,
        handleSubmitCompany,
        reset,
    } = useLogin();

    const handleChangeId = (event: any) => {
        setLoginForm((prev) => ({ ...prev, id: event.target.value.toUpperCase() }));
    };

    const handleChangePassword = (event: any) => {
        setLoginForm((prev) => ({ ...prev, pwd: event }));
    };
    const handleClickRegistration = () => {
        window.location.href = window.location.origin + "/osci/usr/info/osci0103001s?menuId=menu_osci0102";
    };
    const handleClickFind = () => {
        reset();
        navigate(`/findId`);
    };

    // ESW only
    const toggleLicense = (event: any) => {
        setLoginForm((prev) => ({ ...prev, lcm: event.target.checked }));
    };
    // ESW only
    const handleChangeCompany = (event: any) => {
        const co = coTpList.find(({ coDclaCd }: any) => {
            return coDclaCd === event.target.value;
        });
        if (!co) return;
        setLoginForm((prev) => ({ ...prev, coTin: co.coTin, coTpCd: co.coDclaTp, coCd: co.coDclaCd }));
    };

    const handleChangeCustom = (event: any) => {
        if (usrCstmList.findIndex((item) => item.cstmCd === event.target.value) === -1) return;
        setLoginForm((prev) => ({ ...prev, cstmCd: event.target.value }));
    };


    return (
        <>
            {/* Blocking while loading */}
            {loading && (
                <div className="fixed top-0 left-0 w-screen h-screen transition-colors bg-gray/5 z-[999999]">
                    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-primary">
                        <Icon icon="loading" className="animate-spin" />
                    </div>
                </div>
            )}
            <div className={classNames("flex flex-col bg-white px-20 py-12", "sm:p-8")}>
                {/* <div className={classNames("flex flex-col bg-white px-20 py-12 dark:bg-background", "sm:p-8")}> */}
                {type === "login" ? (
                    <form className="flex flex-col gap-[40px] w-full" onSubmit={handleSubmitLogin}>
                        <fieldset className="flex flex-col gap-3">
                            <div className="flex flex-col gap-3">
                                {_TEST1234.SYSTEM_GROUP_ORI === "tanesw" && (
                                    <div className="h-12 rounded border border-blue flex items-center px-[16px] gap-1 text-blue">
                                        <label className="flex items-center gap-2 cursor-pointer">
                                            <input
                                                hidden
                                                className="peer"
                                                type="checkbox"
                                                title="check for remember user information"
                                                checked={lcm}
                                                onChange={toggleLicense}
                                            />
                                            <div className="border rounded-full border-blue w-4 h-4 flex items-center justify-center [&_*]:peer-checked:block">
                                                <Icon className="hidden" icon="check" size="xs" />
                                            </div>
                                            License applicants, please select.
                                        </label>
                                    </div>
                                )}
                                {/* TODO : OGA 로 변경. 기존 시스템에서 로그인 유형 추가. 필요시 해제할 것 */}
                                {false &&
                                    _TEST1234.SYSTEM_GROUP_ORI === "tanoga" && ( // 2025-10-15 KNH 포털 관리도 외부 OGA를 하나 만들어서 처리
                                        // <div className="h-12 rounded border border-blue flex items-center px-[16px] gap-1 text-blue">
                                        <div className="h-12 rounded border border-green flex items-center px-[16px] gap-1 text-green">
                                            <label className="flex items-center gap-2 cursor-pointer">
                                                <input
                                                    hidden
                                                    className="peer"
                                                    type="checkbox"
                                                    title="check for remember user information"
                                                    checked={lcm}
                                                    onChange={toggleLicense}
                                                />
                                                {/* <div className="border rounded-full border-blue w-4 h-4 flex items-center justify-center [&_*]:peer-checked:block"> */}
                                                <div className="border rounded-full border-green w-4 h-4 flex items-center justify-center [&_*]:peer-checked:block">
                                                    <Icon className="hidden" icon="check" size="xs" />
                                                </div>
                                                {/* License applicants, please select. */}
                                                TRA user, please select.
                                            </label>
                                        </div>
                                    )}
                                        {/* <input
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error"
                                            placeholder="Id *"
                                            title="ID"
                                            value={id}
                                            onChange={handleChangeId}
                                        /> */}
                                        <input
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error text-black bg-white focus:outline-none focus:ring-1 focus:ring-[#065F46] focus:border-[#065F46]"
                                            placeholder="Id *"
                                            title="ID"
                                            value={id}
                                            onChange={handleChangeId}
                                        />
                                        {/* <input
                                            type="password"
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error"
                                            placeholder="Password *"
                                            title="password"
                                            value={pwd}
                                            onChange={handleChangePassword}
                                        /> */}
                                        <InputPassword
                                            className="h-12 input rounded px-4 w-full aria-[invalid=true]:border-error text-black bg-white focus:outline-none focus:ring-1 focus:ring-[#065F46] focus:border-[#065F46]"
                                            placeholder="Password *"
                                            value={pwd}
                                            onChange={handleChangePassword}
                                        />
                            </div>
                            <div className="flex gap-1">
                                <input id="saveUserInfo" type="checkbox" title="check for remember user information" />
                                <label htmlFor="saveUserInfo" className="text-black">
                                    Remember me
                                </label>
                            </div>
                        </fieldset>
                        <div className="flex flex-col items-center gap-3">
                            {/* <button
                                className={classNames(
                                    "border h-12 w-full bg-primary rounded-[5px] text-primary-contrast transition-colors hover:bg-primary/80",
                                    loading && "bg-primary/50",
                                )}
                                type="submit"
                            >
                                LOGIN
                            </button> */}
                            <button
                                className={classNames(
                                    "h-12 w-full rounded-full text-white text-lg font-bold transition-colors hover:opacity-90",
                                    loading && "opacity-50",
                                )}
                                style={{ backgroundColor: "#00AD59" }}
                                type="submit"
                            >
                                LOGIN
                            </button>
                                    <button
                                        className="h-12 w-full rounded-full border-2 text-lg font-bold transition-colors hover:opacity-70"
                                        style={{ borderColor: "#00AD59", color: "#00AD59" }}
                                        type="button"
                                        onClick={handleClickRegistration}
                                    >
                                        USER REGISTRATION
                                    </button>

                                    <div className="flex flex-col items-center gap-1">
                                        <button
                                            type="button"
                                            onClick={handleClickFind}
                                            style={{ color: "#00AD59" }}
                                            className="w-full underline text-sm"
                                        >
                                            Forgot your ID
                                        </button>
                                        <DevAccountButton DEV_ACCOUNT={DEV_ACCOUNT_OSC} />
                                    </div>
                        </div>
                    </form>
                ) : type === "company" ? (
                    <form className="flex flex-col gap-[40px] w-full" onSubmit={handleSubmitCompany}>
                        <div className="relative flex w-full items-center">
                            <select
                                className="h-12 input rounded-[5px] px-4 w-full aria-[invalid=true]:border-error appearance-none"
                                value={coCd}
                                onChange={handleChangeCompany}
                            >
                                <option value="">Select Company Code</option>
                                {coTpList?.map(({ coDclaCd, coDclaCdNm }: any) => {
                                    return (
                                        <option key={coDclaCd} value={coDclaCd}>
                                            [{coDclaCd}] {coDclaCdNm}
                                        </option>
                                    );
                                })}
                            </select>
                            <Icon icon="down" size="sm" className="absolute right-[10px] pointer-events-none" />
                        </div>
                        <button
                            className={classNames(
                                "border h-12 w-full bg-primary rounded-[5px] text-white transition-colors hover:bg-primary/80",
                                loading && "bg-primary/50",
                            )}
                            type="submit"
                        >
                            Confirm
                        </button>
                    </form>
                ) : type === "custom" ? (
                    <form className="flex flex-col gap-[40px] w-full" onSubmit={handleSubmitCustom}>
                        <div className="relative flex w-full items-center">
                            <select
                                className="h-12 input rounded-[5px] px-4 w-full aria-[invalid=true]:border-error appearance-none"
                                value={cstmCd}
                                onChange={handleChangeCustom}
                            >
                                <option value="">Custom Office Code</option>
                                {usrCstmList?.map(({ cstmCd, cstmNm }: any) => {
                                    return (
                                        <option key={cstmCd} value={cstmCd}>
                                            {cstmNm}
                                        </option>
                                    );
                                })}
                            </select>
                            <Icon icon="down" size="sm" className="absolute right-[10px] pointer-events-none" />
                        </div>
                        <button
                            className={classNames(
                                "border h-12 w-full bg-primary rounded-[5px] text-white transition-colors hover:bg-primary/80",
                                loading && "bg-primary/50",
                            )}
                            type="submit"
                        >
                            Confirm
                        </button>
                    </form>
                ) : null}
            </div>
        </>
    );
};
